import script from "./MustardOilKhataBook.vue?vue&type=script&setup=true&lang=js"
export * from "./MustardOilKhataBook.vue?vue&type=script&setup=true&lang=js"

import "./MustardOilKhataBook.vue?vue&type=style&index=0&id=ae530522&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae530522"]])

export default __exports__